import * as actionTypes from './types';

const INITIAL_STATE = {
  current: null,
  result: null
  // [
  //   {
  //     id:1,
  //     src: "https://www.barberobillonario.com/wp-content/uploads/2024/08/BarberoBillonario-Logo.png",
  //     alt: "item-1",
  //     name: "BarberBillionare",
  //     time: "13 minutes ago",
  //   },
  //   {
  //     id:2,
  //     src: "https://colombiaxclusive.com/wp-content/uploads/2022/10/Colombiaxclusive-Logo.png",
  //     alt: "item-2",
  //     name: "Colombia Exclusive",
  //     time: "1 day ago",
  //   },
  //   {
  //     id:3,
  //     src: "https://medellinchef.com/wp-content/uploads/2023/10/MC-Logo-New-Letters-Sideways.png",
  //     alt: "item-3",
  //     name: "Medellin Chef",
  //     time: "1 day ago",
  //   },
  // ]
};

const activeReducer = (state = INITIAL_STATE, action) => {
  const { payload = null } = action;
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return INITIAL_STATE;

    case actionTypes.RESET_STATE:
      return INITIAL_STATE;
    case actionTypes.REQUEST_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };
    case actionTypes.REQUEST_SUCCESS:
      return {
        result: payload,
        isLoading: false,
        isSuccess: true,
      };
    default:
      return state;
  }
};

export default activeReducer;